import React from "react";
import DashboardMenu from "../../commonComponents/DashboardMenu";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CancelIcon from "@mui/icons-material/Cancel";
import useStyles from "../DashboardAuction/dashAuction.style";
import buyerListAPI from "../../../api/adminAPI/buyerListAPI";
import { useState, useEffect } from "react";
import moment from "moment";
import DashBuyerDetail from "../DashboardAuction/BidlogFirst/DashBuyerDetail";
import DashEventDetail from "../DashboardAuction/BidlogFirst/DashEventDetail";
import BuyerBidLog from "../DashboardAuction/BidlogFirst/BuyerBidLog";
import { getUserData } from "../../../common";
import { Navigate } from "react-router-dom";

import lodash from "lodash";
import { FaRegFileExcel } from "react-icons/fa";
import * as XLSX from "xlsx";

function DashBuyer() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [changeView, SetChangeView] = useState(false);
  const [buyerEventId, SetBuyerEventId] = useState("");
  const [buyerEventItemId, SetBuyerEvenItemtId] = useState("");
  const [buyerId, SetBuyerId] = useState("");

  const userData = getUserData() ?? {};

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [tableBuyers, setTableBuyers] = useState([]);

  const buyerList = async () => {
    try {
      const { data } = await buyerListAPI();

      if (data) {
        let id = 1;
        const buyersData = data.map((buyer) => {
          return {
            id: id++,
            userName: `${buyer.firstName} ${buyer.lastName}`,
            company: buyer.company,
            email: buyer.email,
            contactNumber: buyer.contactNumber,
            alternateContactNumber: buyer.alternateContactNumber,
            buyerId: buyer.userId,
            h1RanksCount: buyer.h1RanksCount,
            h2RanksCount: buyer.h2RanksCount,
            h3RanksCount: buyer.h3RanksCount,
            totalEvents: buyer.totalEvents,
            totalBidedItems: buyer.totalBidedItems,
            totalItems: buyer.totalItems,
            allotedItems: buyer.allotedItems,
            registrationDate: buyer.createdAt,
          };
        });

        setTableBuyers(buyersData);
      } else throw new Error(data);
    } catch (error) {
      console.log(error);
    }
  };
  React.useEffect(() => {
    buyerList();
    return () => {
      return false;
    };
  }, []);

  const columns = [
    {
      name: "Sr. No.",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.userName,
      sortable: true,
      width: "150px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      width: "300px",
    },
    {
      name: "Mobile Number",
      selector: (row) => row.contactNumber,
      sortable: true,
      width: "150px",
    },
    {
      name: "Alt. Mobile Number",
      selector: (row) => row.alternateContactNumber || "-",
      sortable: true,
      width: "180px",
    },
    {
      name: "Events",
      selector: (row) => row.totalEvents,
      sortable: true,
    },
    {
      name: "Lots",
      selector: (row) => row.totalItems,
      sortable: true,
    },
    {
      name: "Alloeted Lots",
      selector: (row) => row.allotedItems,
      sortable: true,
      width: "130px",
    },
    {
      name: "Bidded Lots",
      selector: (row) => row.totalBidedItems,
      sortable: true,
      width: "130px",
    },
    {
      name: "Lead Bid",
      selector: (row) => row.h1RanksCount,
      sortable: true,
    },
    {
      name: "L2/H2",
      selector: (row) => row.h2RanksCount,
      sortable: true,
    },
    {
      name: "Others",
      selector: (row) => row.h3RanksCount,
      sortable: true,
    },
    {
      name: "Registration Date",
      selector: (row) => moment(row.registrationDate).format("DD/MM/YYYY"),
      sortable: true,
      width: "150px",
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <Button
            className="btn btn-group"
            onClick={() => {
              SetChangeView("DashBuyerDetail");
              SetBuyerId(row.buyerId);
            }}
          >
            View
          </Button>
        </div>
      ),
    },
  ];

  const auctionBuyersListExportToXLSX = (tableData, tableHeader) => {
    const headerColumns = lodash.map(tableHeader, ({ name }) => {
      if (name != "Action") {
        return name;
      }
    });
    const dataColumns = lodash.map(tableData, (columns) => [
      columns.id,
      columns.userName,
      columns.email,
      columns.contactNumber,
      columns.alternateContactNumber,
      columns.totalEvents,
      columns.totalItems,
      columns.allotedItems,
      columns.totalBidedItems,
      columns.h1RanksCount,
      columns.h2RanksCount,
      columns.h3RanksCount,
    ]);

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([headerColumns, ...dataColumns]);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "buyer-list.xlsx");
  };

  const AuctionBuyerListExportButton = () => (
    <Button onClick={() => auctionBuyersListExportToXLSX(tableBuyers, columns)}>
      <FaRegFileExcel
        style={{ fontSize: "30px", color: "#04aa18", paddingTop: "4px" }}
      />
    </Button>
  );

  const renderComponent = () => {
    switch (changeView) {
      case "DashBuyerDetail":
        return (
          <DashBuyerDetail
            DashEventDetail={(buyerId, buyerEventId) => {
              SetChangeView("DashEventDetail");
              SetBuyerEventId(buyerEventId);
            }}
            BidlogFirst={() => {
              SetChangeView("AuctionBid");
            }}
            buyerId={buyerId}
          />
        );
      case "DashEventDetail":
        return (
          <DashEventDetail
            BuyerBidLog={(eventItemId) => {
              SetChangeView("BuyerBidLog");
              SetBuyerEvenItemtId(eventItemId);
            }}
            DashBuyerDetail={(buyerId) => {
              SetChangeView("DashBuyerDetail");
              SetBuyerId(buyerId);
            }}
            buyerId={buyerId}
            buyerEventId={buyerEventId}
          />
        );
      case "BuyerBidLog":
        return (
          <BuyerBidLog
            DashEventDetail={() => {
              SetChangeView("DashEventDetail");
            }}
            buyerId={buyerId}
            buyerEventId={buyerEventId}
            buyerEventItemId={buyerEventItemId}
          />
        );
      default:
        return (
          <div className="AuctionTable">
            {userData.role != "BUYER" ? (
              <>
                <h3>Buyer List</h3>
                <DataTableExtensions
                  print={false}
                  export={false}
                  exportHeaders={false}
                  columns={columns}
                  data={tableBuyers}
                >
                  <DataTable
                    noHeader={false}
                    defaultSortField="id"
                    defaultSortAsc={false}
                    pagination
                    highlightOnHover
                    className="DataTable"
                    actions={<AuctionBuyerListExportButton />}
                  />
                </DataTableExtensions>
              </>
            ) : (
              <Navigate to={{ pathname: "/dashboard" }} />
            )}
          </div>
        );
    }
  };

  return (
    <div className={classes.section}>
      <div className="container">
        <div className={classes.Dashboard}>
          <div className={classes.dashboardCard}>
            <DashboardMenu />
            <div className={classes.dashboardCards}>{renderComponent()}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashBuyer;
